import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback if cookie blocked
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tawbti_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export { API_BASE };
export default api;
